import { render, staticRenderFns } from "./generalSearch.vue?vue&type=template&id=8c3883cc&"
import script from "./generalSearch.vue?vue&type=script&lang=js&"
export * from "./generalSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports